import { useDataValue, useDataSubmit } from 'Simple/Data.js'
import query from './queryDiscussion.graphql.js'
import { useClient, useMutation } from 'Data/Api.js'
import { normalizePath, useSetFlowTo } from 'Simple/Flow.js'
import { notifyError, useNotifications } from 'Logic/Notifications.js'
import { patientName } from 'Data/format.js'
import mutation from './mutationDiscussion.graphql.js'

export default function useDataOnActionDiscussion(props) {
  let client = useClient()
  let [, notify] = useNotifications()
  let [, executeMutation] = useMutation(mutation)
  let setFlowTo = useSetFlowTo(props.viewPath)

  let submit = useDataSubmit({
    context: 'tab',
    viewPath: props.viewPath,
  })

  let patient_id = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: '_id',
  })
  let person = useDataValue({
    viewPath: props.viewPath,
    context: 'patient',
    path: 'person',
  })

  let parent_company_id = useDataValue({
    viewPath: props.viewPath,
    context: 'global',
    path: 'current_location.parent_company._id',
  })

  return async function onActionDiscussion({
    value,
    originalValue,
    args,
    change,
  }) {
    let { data, error } = await client
      .query(
        query,
        {
          patient_id,
        },
        {
          requestPolicy: 'network-only',
        }
      )
      .toPromise()

    if (error) {
      return notify(notifyError(`There was a problem opening this record.`))
    }

    let thread = null
    if (data.comms_threads.length > 0) {
      thread = data.comms_threads[0]
    } else {
      let mutationResponse = await executeMutation({
        resource: {
          schema: 'vaxiom',
          table: 'patients',
          id: patient_id,
        },
        thread_name: patientName(person).concat(' - Patient'),
        parent_company_id,
      })

      if (mutationResponse.error) {
        return notify(
          notifyError(`There was a problem starting this discussion.`)
        )
      }

      thread = mutationResponse.data.thread
    }

    submit({
      type: 'tab/openCommsThread',
      thread_id: thread.id,
    })

    // close dropdown
    setFlowTo(normalizePath(props.viewPath, 'Content/No'))
  }
}
